import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CheckoutOrderFragment, OrderStatus } from '@websky/graphql';
import { useConfig } from '@websky/core/src/context';
import Checkbox from './Checkbox/Checkbox';

interface Props {
	order: CheckoutOrderFragment;
}

const PassengerToolbarAdditional: React.FC<Props> = ({ order }) => {
	const { t } = useTranslation('Checkout');
	const { subsidyRulesUrl, transferBaggageUrl } = useConfig().global.companyInfo;

	const hasSubsidizedMessage = order.messages?.find(
		message => message.code === 'Subsidized1' || message.code === 'Subsidized2'
	);

	const hasSvxMessage = order.messages?.find(message => message.code === 'mvlsvx');

	if (
		!order ||
		order.status !== OrderStatus.New ||
		!order.messages?.length ||
		!(hasSubsidizedMessage || hasSvxMessage)
	) {
		return null;
	}

	return (
		<>
			{hasSubsidizedMessage && (
				<Checkbox
					name="subsidyCheck"
					label={t('I agree with subsidy fares and rules', { subsidyUrl: subsidyRulesUrl })}
				/>
			)}

			{hasSvxMessage && (
				<Checkbox
					name="transferCheck"
					label={t('I agree with the rules for checking in transfer baggage at Koltsovo airport', {
						transferBaggageUrl
					})}
				/>
			)}
		</>
	);
};

export default PassengerToolbarAdditional;
